import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormStateService } from '../../module/service-provider/add-sp-new-component/form-state.service';
import { FormlyConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldFile } from '../../module/service-provider/file-type';

@Component({
  selector: 'app-addressproof',
  templateUrl: './addressproof.component.html',
  styleUrl: './addressproof.component.scss'
})
export class AddressproofComponent implements OnInit, OnDestroy {
  resetForm() {
  }

  @Output() nextSection = new EventEmitter<void>();
  locationData: any = {};
  form = new FormGroup({});
  model: any = {};
  role: string = '';
  fields: FormlyFieldConfig[] = [];
  @Input() formStateService: any;
  @Input() formSource: any = 'unknown';

  constructor(
    private formstate: FormStateService,
    private formlyConfig: FormlyConfig
  ) { }

  ngOnInit() {
    this.formstate.setFormData('address-proof', null);
    this.loadSavedLocation();
    this.patchForm();
    this.initializeFields()
    //this.registerFormlyTypes();
    if (!this.formlyConfig.getType('file')) {
      this.formlyConfig.setType({
        name: 'file',
        component: FormlyFieldFile,
      });
    }
  }
  ngOnDestroy(): void {
    this.saveData()
  }

  initializeFields() {
    this.fields = [
      {
        key: 'addressProof',
        type: 'file',
        templateOptions: {
          placeholder: 'Upload Address Proof',
          required: true,
          description: 'Supported file format: [pdf, jpg, jpeg, png, doc, docx]',

        },
        validation: {
        messages: {
          required: () => 'Upload address proof'
        }
      }
      },
    ]
  }
  loadSavedLocation(): void {
    const savedAddress = this.formstate.getFormData('address-proof');
    if (savedAddress) {
      const { fileName, fileUrl, file } = savedAddress;
      console.log('Loaded Data:', savedAddress);
      this.locationData = savedAddress;
      this.patchForm();
    } else {
      console.log('No data available.');
    }
  }

  patchForm(): void {
    const savedAddressProof = this.formstate.getFormData('address-proof');
    if (savedAddressProof) {
      console.log('patch', savedAddressProof.addressProof)
      this.model.addressProof = savedAddressProof.addressProof
      console.log(this.model.addresProof)
      console.log('Form patched with saved address proof and location data:', savedAddressProof);
    }
  }
  onFinish(): void {

    if (this.form.invalid) {
    this.form.markAllAsTouched(); 
    console.log('Form is invalid. Please correct the errors before proceeding.');
    return;
  }
    const addressProofFileId = this.form.get('addressProof')?.value;

    if (!addressProofFileId) {
      console.log('Please upload a valid address proof.');
      return;
    }

    const addressProofDoc = {
      documentTypeId: 5,
      fileId: addressProofFileId,
    };

    // Only save to formStateService if NOT 'Service-Provider'
    if (this.formSource !== 'Service-Provider') {
      this.formstate.setFormData?.('address-proof', addressProofDoc);
      this.formStateService?.setAddressProofDetails?.(addressProofDoc);
      console.log('Saved Address Proof Document to state:', addressProofDoc);
    } else {
      console.log('Service-Provider mode: Skipped saving address proof to form state');
    }

    this.nextSection.emit();
  }

  populateAddressProofFromResponse(response: any): void {
    let documentList: any[] = [];
    console.log('Full response in populateAddressProofFromResponse:', response);

    // Determine which document array to use based on formSource
    if (this.formSource === 'Distributor') {
      if (Array.isArray(response.documents)) {
        documentList = response.documents;
      } else if (Array.isArray(response.distributorDocuments)) {
        documentList = response.distributorDocuments;
      } else if (Array.isArray(response.businessDetails?.documents)) {
        documentList = response.businessDetails.documents;
      }
    } else if (this.formSource === 'Advisor' && Array.isArray(response.serviceAdvisorDocuments)) {
      documentList = response.serviceAdvisorDocuments;
    } else if (this.formSource === 'User' && Array.isArray(response.vehicleDetail?.documents)) {
      console.log('Recieving the docs', response.vehicleDetail?.documents)
      documentList = response.vehicleDetail.documents;
    } else if (this.formSource === 'Service-Provider') {
      if (Array.isArray(response.serviceProviderDocuments)) {
        documentList = response.serviceProviderDocuments;
      } else {
        console.warn('For Service-Provider, response.serviceProviderDocuments is not an array. Response:', response);
        return;
      }
    } else {
      console.warn('No valid document list found in response for source:', this.formSource);
      return;
    }

    console.log('Document list found:', documentList);

    const addressProofDoc = documentList.find((doc: any) => doc.documentTypeId === 5);

    if (addressProofDoc && addressProofDoc.fileId) {
      // Patch the form control for UI purposes
      this.form.patchValue({
        addressProof: addressProofDoc.fileId,
      });

      this.model.addressProof = addressProofDoc.fileId;

      // Build an object with address proof data
      const addressProofData = {
        addressProofFileId: addressProofDoc.fileId,
        fileName: addressProofDoc.fileName,
        fileUrl: addressProofDoc.filePath,
      };

      // Only save into the state if the source is not 'Service-Provider'
      if (this.formSource !== 'Service-Provider') {
        this.formstate.setFormData?.('address-proof', addressProofData);
        this.formStateService?.setAddressProofDetails?.({
          documentTypeId: 5,
          fileId: addressProofDoc.fileId,
        });
        console.log('Saved address proof data to form state:', addressProofData);
      } else {
        console.log('Service-Provider mode: Not saving address proof to form state.');
      }

      console.log('Address proof patched from response:', addressProofData);
    } else {
      console.log('Address proof document (documentTypeId 5) not found in the documents:', documentList);
    }

    this.initializeFields();
    console.log('Form source', this.formSource)
  }
  private saveData(): void {
    const formData: any = { ...this.form.value };
    const addressProofFileId = this.form.get('addressProof')?.value;

    const addressProofDoc = {
      documentTypeId: 5,
      fileId: addressProofFileId,
    };

    this.formstate.setFormData('address-proof', formData);
    if (this.formSource !== 'Service-Provider') {
      this.formStateService?.setAddressProofDetails?.(addressProofDoc);
      console.log('[OnDestroy] Saved address proof to form state:', addressProofDoc);
    } else {
      console.log('[OnDestroy] Service-Provider mode: Skipping state save');
    }
  }


}
